/* This file is autogenerated, see readme.md for instructions */
import ColorPickerSvgIcon from '@bloomreach/banana-theme/icons/color-picker.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ColorPickerIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ColorPickerSvgIcon />
    </Icon>
  );
});

ColorPickerIcon.displayName = 'ColorPickerIcon';

export default ColorPickerIcon;
